import { AnyAction } from "redux";
import { IFilterOptions } from "../../types/filters.types";
import { DCResearchCards } from "../../types/cards.types";

export const GET_DC_RESEARCH_DATA = "GET_DC_RESEARCH_DATA";
export const GET_DC_RESEARCH_DATA_SUCCESS = "GET_DC_RESEARCH_DATA_SUCCESS";
export const GET_DC_RESEARCH_DATA_ERROR = "GET_DC_RESEARCH_DATA_ERROR";

export interface IDCResearchReducer {
  isDcResearchCardsLoading: boolean;
  dcResearchData: DCResearchCards | null;
}

export const fetchDcResearchData = (
  filters: IFilterOptions,
  fields: string[]
) => ({
  type: GET_DC_RESEARCH_DATA,
  value: {
    filters,
    fields,
  },
});

export const fetchDcResearchDataSuccess = (
  value: Partial<DCResearchCards>
) => ({
  type: GET_DC_RESEARCH_DATA_SUCCESS,
  value,
});

export const fetchDcResearchDataError = () => ({
  type: GET_DC_RESEARCH_DATA_ERROR,
});

export const initialState: IDCResearchReducer = {
  isDcResearchCardsLoading: false,
  dcResearchData: null,
};

export const dcResearchReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case GET_DC_RESEARCH_DATA:
      return {
        ...state,
        isDcResearchCardsLoading: true,
        dcResearchData: null,
      };
    case GET_DC_RESEARCH_DATA_SUCCESS:
      return {
        ...state,
        isDcResearchCardsLoading: false,
        dcResearchData: action.value,
      };
    case GET_DC_RESEARCH_DATA_ERROR:
      return {
        ...state,
        isDcResearchCardsLoading: false,
      };
    default:
      return state;
  }
};

export default dcResearchReducer;
